/**
 * Related to substitutions
 */
export const INITIALIZE = 'initialize'

export const LOAD_STATE = 'load_state'

export const CLEAR_STATE = 'clear_state'

export const UPDATE_AXIS_VALUE = 'update_axis_value'

export const ADD_NEW_SUBSTITUTION = 'new_substitution'

export const DELETE_SUBSTITUTION = 'delete_substitution'

export const ACTIVATE_SUBSTITUTION = 'activate_substitution'

export const SET_AXIS_DIMENSION_FOR_SUBSTITUTION = 'set_axis_dimension_for_substitution'

export const SET_AXIS_SUBDIVISIONS_FOR_SUBSTITUTION = 'set_axis_subdivisions_for_substitution'

export const UPDATE_SEQUENCE_FOR_SUBSTITUTION = 'update_sequence'

export const SET_STATE_FOR_CELL = 'set_state_for_cell'

/**
 * Related to subordinates
 */

export const ADD_SUBORDINATE_TO_SUBSTITUTION = 'add_subordinate_to_substitution'

export const REMOVE_SUBORDINATE_FROM_SUBSTITUTION = 'remove_subordinate_from_substitution'

export const SWAP_SUBORDINATE_AND_PRIMARY = 'swap_subordinate_and_primary'

export const ACTIVATE_SUBORDINATE_IN_GRID = 'activate_subordinate_in_grid'

export const DEACTIVATE_SUBORDINATE_IN_GRID = 'deactivate_subordinate_in_grid'



// WEBPACK FOOTER //
// ./src/store/mutations.js